const Footer = ({ setShowImpressum, setShowDatenschutz }) => {
    return (
        <footer className=" pt-8 ">
<div className="pt-8 w-full bg-[#C5DEEB] h-auto px-5">
    {/* Constraint Container: Centers content and limits width to 1280px */}
    <div className="w-full dpr-max-w-container mx-auto">

        {/* Bottom Navigation */}
        <div className='flex justify-end pb-8'>
            <button onClick={() => setShowImpressum(true)} className="text-primary-plain-Color hover:underline pr-4">Impressum</button>
            <button onClick={() => setShowDatenschutz(true)} className="text-primary-plain-Color hover:underline pr-0">Datenschutz</button>
        </div>

    </div>
</div>
        </footer>
    )
}

export default Footer